import { createSlice } from '@reduxjs/toolkit';

const alertSlice = createSlice({
  name: 'alerts',
  initialState: { bySymbol:{}, loading:false, loaded:false, feedback:null },
  reducers: {
    upsertAlert(state, a) {
      const { symbol, alertData } = a.payload;
      if (!state.bySymbol[symbol]) state.bySymbol[symbol] = [];
      const idx = state.bySymbol[symbol].findIndex(al => al.id===alertData.id);
      if (idx>=0) state.bySymbol[symbol][idx] = alertData;
      else state.bySymbol[symbol].push({ ...alertData, id: alertData.id||Date.now().toString() });
    },
    removeAlert(state, a) {
      const { symbol, id } = a.payload;
      if (state.bySymbol[symbol]) state.bySymbol[symbol] = state.bySymbol[symbol].filter(al=>al.id!==id);
    },
    clearAlertFeedback(state) { state.feedback = null; },
    setAlertLoading(state, a) { state.loading = a.payload; },
    setAlertLoaded(state, a)  { state.loaded = a.payload; },
  },
});

export const { upsertAlert, removeAlert, clearAlertFeedback, setAlertLoading, setAlertLoaded } = alertSlice.actions;
export default alertSlice.reducer;
